<template>
<div class="table-responsive">    
<table class="table v-middle">
    <thead>
        <tr class="">
            <th class="border-top-0">Страна</th>
            <th class="border-top-0">Заражено</th>
            <th class="border-top-0">Сегодня заражено</th>
            <th class="border-top-0">Смертей</th>
            <th class="border-top-0">Сегодня Смертей</th>
            <th class="border-top-0">Выздоровили</th>
            <th class="border-top-0">Активных (больных)</th>
            <th class="border-top-0">Критическое состояние</th>
        </tr>
    </thead>
    <tbody>
        <tr v-for="(item, index) in cor" :key="index">
            <td><h5 class="m-b-0">{{item.country}}</h5></td>
            <td>{{item.cases}}</td>
            <td>{{item.todayCases}}</td>
            <td>{{item.deaths}}</td>
            <td>{{item.todayDeaths}}</td>
            <td>{{item.recovered}}</td>
            <td>{{item.active}}</td>
            <td>{{item.critical}}</td>
        </tr>        
    </tbody>
</table>
</div>
</template>
<script>
import axios from 'axios';
export default {
    name: "TopProducts",
    data() {
    return {
      cor:[]
    }
  },
  created(){
    axios.get('https://coronavirus-19-api.herokuapp.com/countries').then(({data})=>{
      this.cor = data;
    })
  }
}
</script>
